const $window = $(window);
const mobileBreakpoint = 767;

const handleMenuDropdown = () => {
  if ($window.innerWidth() <= mobileBreakpoint) {
    return;
  }

  const $trigger = $('.nav-utilities > ul > .menu__item > a').not('.menu__close');

  $trigger.on('click', function(event) {
    const $this = $(this);
    const $parent = $this.closest('li');
    const $searchPanel = $('.search-panel');
    const hasOpenDropdown = $parent.siblings('.menu__item--open-dropdown').length > 0;
    const hasOpenSearchPanel = $searchPanel.hasClass('is-active');

    // Set offset top position on dropdowns and close buttons
    setOffsetTop();

    if (hasOpenDropdown) {
      toggleMenuDropdown($parent.siblings('.menu__item--open-dropdown').find('> a').not('.menu__close'));

      setTimeout(function() {
        toggleMenuDropdown($this);
      }, 400);
    } else if (hasOpenSearchPanel) {
      $searchPanel.removeClass('is-active');

      setTimeout(function() {
        toggleMenuDropdown($this);
      }, 400);
    } else {
      toggleMenuDropdown($this);
    }

    event.preventDefault();
  });

  $('.menu__close').on('click', function(event) {
    toggleMenuDropdown($(this).siblings('a'));

    event.preventDefault();
  });
}

handleMenuDropdown();

const toggleMenuDropdown = ($trigger) => {
  const $parent = $trigger.closest('li');
  const $dropdown = $trigger.siblings('ul');
  const $closeDropdownButton = $trigger.siblings('a');

  $parent
    .toggleClass('menu__item--open-dropdown');

  $dropdown
    .toggleClass('is-active');

  $closeDropdownButton
    .toggleClass('is-active');
}

const setOffsetTop = () => {
  const $dropdowns = $('.nav-utilities > ul > li > .menu__dropdown');
  const $closeButtons = $('.nav-utilities > ul > li > .menu__close');
  const $headerBar = $('.header .header__bar');
  let offsetTop = 0;

  if ($headerBar.length > 0) {
    offsetTop = $headerBar.outerHeight();
  }

  $dropdowns
    .css('top', offsetTop);

  $closeButtons
    .css('transform', 'translateY(' + offsetTop + 'px)');
}
